import React from "react";

export enum SwipeDirectionEnum {
    Backward = -1,
    Initial = 0,
    Forward = 1
}

export interface ISparkSwiperSlideController {
    readonly key: string;
    readonly itemIndex: number;
    readonly itemIndexOffset: number;
    readonly isActiveSlide: boolean;
    renderSlideContent(): React.ReactElement;
    onBeforeDeactivate(swipeDirection: SwipeDirectionEnum): void;
    onAfterActivated(swipeDirection: SwipeDirectionEnum): void;

}